import { useEffect } from "react";

const sleep=(ms:number)=>new Promise(resolve=>window.setTimeout(resolve,ms));
const clean=(value:string|null|undefined)=>(value||"").replace(/\s+/g," ").trim();

function clickNav(label:string){
  const buttons=[...document.querySelectorAll<HTMLButtonElement>(".app-shell nav button")];
  const button=buttons.find(b=>clean(b.textContent).includes(label));
  button?.click();
  return Boolean(button);
}

async function openProcedure(title:string){
  if(!clickNav("WPS / WPDS Library"))return;
  for(let attempt=0;attempt<30;attempt++){
    await sleep(100);
    const rows=[...document.querySelectorAll<HTMLTableRowElement>(".procedure-table tbody tr")];
    const row=rows.find(r=>clean(r.querySelector("td:first-child b")?.textContent)===title);
    if(row){row.scrollIntoView({behavior:"smooth",block:"center"});row.click();return;}
  }
}

async function openWelder(title:string,isAluminum:boolean){
  if(!clickNav("Welder Qualifications"))return;
  for(let attempt=0;attempt<20;attempt++){
    await sleep(75);
    const controls=[...document.querySelectorAll<HTMLButtonElement>(".division-control button, button")];
    const wanted=isAluminum?"aluminum":"steel";
    const division=controls.find(b=>clean(b.textContent).toLowerCase().includes(wanted));
    if(division){division.click();break;}
  }
  for(let attempt=0;attempt<30;attempt++){
    await sleep(100);
    const rows=[...document.querySelectorAll<HTMLTableRowElement>("table tbody tr")];
    const row=rows.find(r=>clean(r.querySelector("td:first-child b")?.textContent)===title);
    if(row){
      row.scrollIntoView({behavior:"smooth",block:"center"});
      row.dataset.openWelderProfile="true";
      row.click();
      window.setTimeout(()=>delete row.dataset.openWelderProfile,0);
      return;
    }
  }
}

async function openGeneric(label:string,title:string){
  if(!clickNav(label))return;
  for(let attempt=0;attempt<30;attempt++){
    await sleep(100);
    const candidates=[...document.querySelectorAll<HTMLElement>(".content tbody tr, .content article, .content .project-card, .content .requirement-card")];
    const item=candidates.find(x=>clean(x.textContent).toLowerCase().includes(title.toLowerCase()));
    if(item){item.scrollIntoView({behavior:"smooth",block:"center"});item.click();return;}
  }
}

export default function SearchResultRecordNavigation(){
  useEffect(()=>{
    const onClick=(event:MouseEvent)=>{
      const button=(event.target as HTMLElement).closest(".cert-search-results > button") as HTMLButtonElement|null;
      if(!button)return;
      const kind=clean(button.querySelector("small")?.textContent).toUpperCase();
      const title=clean(button.querySelector("b")?.textContent);
      if(!kind||!title)return;
      const text=clean(button.textContent).toUpperCase();

      window.setTimeout(()=>{
        if(kind==="WPS"||kind==="WPDS"||kind==="PROCEDURE")void openProcedure(title);
        else if(kind==="WELDER QUALIFICATION"||kind==="WELDER ACTIVITY / MONTHLY LOG")void openWelder(title,text.includes("ALUMINUM")||text.includes("W47.2"));
        else if(kind==="PROJECT"||kind==="DRAWING"||kind==="WELD REQUIREMENT"||kind==="WELD REGISTER")void openGeneric("Projects",title);
        else if(kind==="MTR")void openGeneric("Material Test Reports",title);
        else if(kind.includes("INSPECTION")||kind==="HOLD POINT"||kind==="ITP")void openGeneric("Inspection & Testing",title);
        else if(kind==="NCR")void openGeneric("Non-Conformance Reports",title);
        else if(kind==="EQUIPMENT"||kind==="MAINTENANCE"||kind==="CALIBRATION")void openGeneric("Maintenance & Calibration",title);
      },50);
    };
    document.addEventListener("click",onClick,true);
    return()=>document.removeEventListener("click",onClick,true);
  },[]);
  return null;
}
